module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    attrs: {
      "theme": "light",
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-submenu', {
    staticStyle: {
      "float": "right",
      "margin-right": "10px"
    },
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-1"
    }
  }, [_vm._v("Logout")])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e926e170","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Navbar.vue
// module id = 771
// module chunks = 2